import React from "react";
import { useSwipeable } from "react-swipeable";


 
const defaultProps = {
  className: "",
  delta: 0,
  onSwiping: () => {//do nothing
  },
  onSwiped: () => {//do nothing
  },
};
 

const SwipeWrapper: React.FC<React.PropsWithChildren<{
  className: string,
  delta: number,
  onSwiped: () => void,
  onSwiping: () => void,
}>> = (props) => {
  const { children, className, delta, onSwiping, onSwiped } = {
    ...defaultProps,
    ...props,
  };
  const swipeHandlers = useSwipeable({
    delta,
    onSwiping,
    onSwiped,
  });
  return (
    <div {...swipeHandlers} className={className}>
      {children}
    </div>
  );
};

export default SwipeWrapper;
